export default {
  HOME: 'Home',
  SIGN_UP: 'SignUp',
  SIGN_UP_OUT_OF_TEST: 'SignUpBOutOfTest',
  SIGN_IN: 'SignIn',
  CONFIRMATION_CODE: 'ConfirmationCode',
  CHANGE_PHONE: 'ChangePhone',
  CITY_SELECTION: 'CitySelection',
  COURSE_SELECTION: 'CourseSelection',
  CAMPUS_SELECTION: 'CampusSelection',
  ADMISSION_TYPE_SELECTION: 'AdmissionTypeSelection',
  ESSAY_THEME_SELECTION: 'EssayThemeSelection',
  ESSAY_THEME_SUPPORT_TEXT: 'EssayThemeSupportText',
  ESSAY_SEND: 'EssaySend',
  ENEM_YEAR_SELECTION: 'EnemYearSelection',
  ENEM_SUBSCRIPTION_NUMBER: 'EnemSubscriptionNumber',
  ENEM_GRADES: 'EnemGrades',
  ADMISSION_RESULT: 'AdmissionResult',
  SECOND_GRADUATION_INSTITUTION_INFO: 'SecondGraduationInstitutionInfo',
  SECOND_GRADUATION_SEND_DOCUMENT: 'SecondGraduationSendDocument',
  TRANSFER_GRADUATION_INSTITUTION_INFO: 'TransferGraduationInstitutionInfo',
  TRANSFER_GRADUATION_SEND_DOCUMENT: 'TransferGraduationSendDocument',
};
